import { LOGO_URL } from "../constants";
import { LANGS, useLang } from "../i18n";

export default function Footer() {
  const { t, lang, setLang } = useLang();

  return (
    <footer id="contact" className="border-t border-gold/15 px-6 pb-10 pt-20 md:px-12" data-testid="footer">
      <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
        <div className="flex items-center gap-4">
          <img src={LOGO_URL} alt="III ROMA" className="h-14 w-14 rounded-full border border-gold/40 object-cover" />
          <div>
            <p className="font-display text-sm tracking-[0.4em] text-parchment">III ROMA</p>
            <p className="mt-1 text-[0.6rem] uppercase tracking-[0.35em] text-gold">{t("hero.tagline")}</p>
          </div>
        </div>
        <div className="flex flex-col gap-2" data-testid="footer-contact">
          <p className="text-[0.6rem] uppercase tracking-[0.35em] text-stone">{t("footer.contact")}</p>
          <a href="mailto:info@iiiroma.com" data-testid="footer-email" className="text-base text-gold transition-colors hover:text-parchment">
            {t("footer.email")}
          </a>
          <p className="text-base text-parchment/60">{t("footer.location")}</p>
        </div>
        <div className="flex flex-wrap gap-3" data-testid="footer-langs">
          {LANGS.map((l) => (
            <button
              key={l.code}
              data-testid={`footer-lang-${l.code}`}
              onClick={() => setLang(l.code)}
              className={`border px-3 py-1.5 text-[0.6rem] tracking-[0.2em] transition-colors duration-300 ${
                lang === l.code ? "border-gold bg-gold text-obsidian" : "border-gold/30 text-gold hover:border-gold/70"
              }`}
            >
              {l.label}
            </button>
          ))}
        </div>
      </div>

      <h2 className="font-display text-carved-gold mt-16 select-none text-[16vw] font-black leading-none md:text-[11vw]" data-testid="footer-wordmark">
        III ROMA
      </h2>

      <div className="mt-6 flex flex-col gap-3 border-t border-gold/10 pt-6 md:flex-row md:items-center md:justify-between">
        <p className="text-[0.6rem] uppercase tracking-[0.3em] text-stone">
          © {new Date().getFullYear()} III ROMA — {t("hero.tagline")} · {t("footer.rights")}
        </p>
        <p className="text-[0.6rem] uppercase tracking-[0.3em] text-stone/50">ROMA · OMNIA VINCIT TEMPORES</p>
      </div>
    </footer>
  );
}
